import { supabase } from "@/integrations/supabase/client";

export interface ReportPlacePayload {
  placeId?: string;
  placeSlug: string;
  placeName: string;
  reportType: string;
  message: string;
}

export interface ReportPlaceResult {
  success: boolean;
  error?: string;
}

export async function reportPlace(payload: ReportPlacePayload): Promise<ReportPlaceResult> {
  try {
    const { data, error } = await supabase.functions.invoke("farmly-report-place", {
      body: {
        placeId: payload.placeId,
        placeSlug: payload.placeSlug,
        placeName: payload.placeName,
        reportType: payload.reportType,
        message: payload.message,
        pageUrl: typeof window !== "undefined" ? window.location.href : undefined,
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
      },
    });

    if (error) {
      console.error("Report place error:", error);
      return { success: false, error: error.message || "Kunde inte skicka rapporten" };
    }

    if (data && !data.ok) {
      return { success: false, error: data.error || "Något gick fel" };
    }

    return { success: true };
  } catch (err) {
    console.error("Unexpected error reporting place:", err);
    return { success: false, error: "Ett oväntat fel uppstod" };
  }
}

export function getMailtoFallback(payload: ReportPlacePayload): string {
  const subject = encodeURIComponent(`Rapportera fel: ${payload.placeName || payload.placeSlug}`);
  
  const reportTypeLabels: Record<string, string> = {
    wrong_address: "Fel adress",
    closed: "Stängt",
    wrong_link: "Fel länk",
    other: "Annat",
  };
  
  const body = encodeURIComponent(
    `Plats: ${payload.placeName || "–"}\n` +
    `Slug: ${payload.placeSlug || "–"}\n` +
    `Typ: ${reportTypeLabels[payload.reportType] || payload.reportType}\n\n` +
    `Meddelande:\n${payload.message}\n\n` +
    `Skickad från: ${typeof window !== "undefined" ? window.location.href : "–"}`
  );
  
  return `mailto:hello@farmly.se?subject=${subject}&body=${body}`;
}